import { useContext } from 'react';
import { CurrentReservesContext } from '../CurrentReservesContext';

export * from './CurrentReservesContext';

export const useCurrentReservesContext = () => useContext(CurrentReservesContext);
